export default __webpack_public_path__ + "static/grafika_promo-bef8d859ae99c75053b8cf64acb48f28.png";